import { useEffect, useState } from 'react';
import { Download, X } from 'lucide-react';
import './InstallPrompt.css';

const DISMISS_KEY = 'skyleaf-install-dismissed-at';
const DISMISS_DAYS = 14;

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissedAt = Number(localStorage.getItem(DISMISS_KEY) || 0);
    const daysSinceDismiss = (Date.now() - dismissedAt) / (1000 * 60 * 60 * 24);
    if (dismissedAt && daysSinceDismiss < DISMISS_DAYS) return undefined;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };
    window.addEventListener('beforeinstallprompt', handler);

    const onInstalled = () => {
      setVisible(false);
      setDeferredPrompt(null);
    };
    window.addEventListener('appinstalled', onInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setVisible(false);
  };

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="install-prompt">
      <button className="install-prompt-dismiss" onClick={handleDismiss} aria-label="Dismiss">
        <X size={14} />
      </button>
      <div className="install-prompt-icon"><Download size={18} /></div>
      <div className="install-prompt-text">
        <strong>Install Skyleaf Travels</strong>
        <span>Quick access, right from your home screen.</span>
      </div>
      <button className="btn btn-primary btn-sm" onClick={handleInstall}>Install</button>
    </div>
  );
}
